import { useRoundable } from "./useRoundable.mjs";
import { computed } from "vue";
export function useGridDisplayable(props) {
  const { roundableString } = useRoundable(props);
  const responsiveGridBorderRadiusClass = computed(() => {
    let roundedClass = roundableString;
    if (!roundedClass) {
      return null;
    }
    let borderRadiusClass = [];
    if (props.lgTile) {
      borderRadiusClass.push("lg:rounded-none");
    }
    if (props.mdTile) {
      borderRadiusClass.push("md:rounded-none");
      if (!props.lgTile) {
        borderRadiusClass.push(`lg:${roundedClass}`);
      }
    }
    if (props.smTile) {
      borderRadiusClass.push("sm:rounded-none");
      if (!props.mdTile) {
        borderRadiusClass.push(`md:${roundedClass}`);
      }
    }
    if (props.xsTile) {
      borderRadiusClass.push("xs:rounded-none");
      if (!props.smTile) {
        borderRadiusClass.push(`sm:${roundedClass}`);
      }
    } else {
      borderRadiusClass.push(roundedClass);
    }
    return borderRadiusClass.join(" ");
  });
  return {
    responsiveGridBorderRadiusClass
  };
}
